<template>
	<div>
		<h1>Study Setting</h1>
		<i
			>Description of study settings (eg, community clinic, academic hospital)
			and list of countries where data will be collected.</i
		>

		<InputSelectMulti
			question="Where will participants be recruited from?"
			:options="settingOptions"
			v-model="$tera.project.TrialWizard.settings"
			bookmark="study-setting"
		/>

		<InputSelectMulti
			question="Which regions will participants be recruited from?"
			:options="locationOptions"
			v-model="$tera.project.TrialWizard.regions"
			bookmark="recruited-from"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputStudySetting from "./OutputStudySetting.vue";

export default {
	data() {
		return {
			locationOptions: [
				{ label: "Australia" },
				{ label: "China" },
				{ label: "Japan" },
				{ label: "Norway" },
				{ label: "Ukraine" },
				{ label: "United Kingdom" },
				{ label: "United States" }
			],
			outputComponent: OutputStudySetting,
			settingOptions: [
				{ label: "Hospitals" },
				{ label: "Outpatient clinics" },
				{ label: "General practices" },
				{ label: "The community" }
			]
		};
	}
};
</script>
